import { get, put, urlApiTegra } from "../../../service/api";

export const getCorporationData = (token: string): Promise<any> => {
  return get(`${urlApiTegra}/corporation`, token);
};

export const updateCorporation = ({ body, token }: { body: any; token: string }) => {
  return put(`${urlApiTegra}/corporation`, body, token);
};
